module.exports = __webpack_public_path__ + "img/kr-product-title-img-4.c767e43.png";